/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RetryFlowRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/retry_flow.pb'
import {RetryFlowResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/retry_flow.pb'


export const retryFlow = (request: RetryFlowRequest, options?: CashRequestOptions) => post<RetryFlowRequest, RetryFlowResponse>("/2.0/cash/retry-flow", request, {...options, rejectOnError: true })